export var maskingClassNames = 'fs-mask sensitive-information';
//# sourceMappingURL=constants.js.map